<h3 color="primary"  *ngIf="data.apiName == 'userAcitivityLog'" class="popup-header">User Activity Logs</h3>
<h3 color="primary"  *ngIf="data.apiName == 'userProfileAcitivityLog'" class="popup-header">User Profile Logs</h3>
<h3 color="primary"  *ngIf="data.apiName == 'getRoleAcitivityLog'" class="popup-header">Role Logs</h3>
<h3 color="primary"  *ngIf="!isFromUser || data.apiName == 'getTestCodeLogs'" class="popup-header">Logs</h3>
<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="isFromUser">
    <ng-container *ngIf="data.apiName == 'userAcitivityLog'">
      <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
        [pageSettings]="pageSettings" (dataStateChange)='dataStateChange($event)' [height]="sharedService.ejsGridHeight">
        <e-columns>
          <e-column field='timeLogged' headerText='Time Logged' width=30>
            <ng-template #template let-data>
              {{data.timeLogged | date:'MM/dd/yyyy hh:mm:a'}}
            </ng-template>
          </e-column>
          <e-column field='logText' headerText='Log Text' width=70></e-column>
        </e-columns>
      </ejs-grid>
      <app-total-record-count [count]="dataList.count"></app-total-record-count>
    </ng-container>
    <ng-container *ngIf="data.apiName == 'userProfileAcitivityLog'">
      <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
        [pageSettings]="pageSettings" (dataStateChange)='dataStateChange($event)' [height]="sharedService.ejsGridHeight">
        <e-columns>
          <e-column field='createdDateTime' headerText='Time Logged' width=15>
            <ng-template #template let-data>
              {{data.createdDateTime | date:'MM/dd/yyyy h:mm a'}}
            </ng-template>
          </e-column>
          <e-column field='userName' headerText='User' width=30></e-column>
          <e-column field='changeLog' headerText='Log Text' width=80></e-column>
        </e-columns>
      </ejs-grid>
      <app-total-record-count [count]="dataList.count"></app-total-record-count>
    </ng-container>
    <ng-container *ngIf="data.apiName == 'getRoleAcitivityLog' || data.apiName == 'getTestCodeLogs'">
      <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
        [pageSettings]="pageSettings" (dataStateChange)='dataStateChange($event)' [height]="sharedService.ejsGridHeight">
        <e-columns>
          <e-column field='createdDateTime' headerText='Date' width=15>
            <ng-template #template let-data>
              {{data.createdDateTime | date:'MM/dd/yyyy h:mm a'}}
            </ng-template>
          </e-column>
          <e-column field='userName' headerText='User' width=30></e-column>
          <e-column field='tableName'  [visible]="data.apiName == 'getTestCodeLogs'" headerText='Table' width=30></e-column>
          <e-column field='changeLog' headerText='Log' width=80></e-column>
        </e-columns>
      </ejs-grid>
      <app-total-record-count [count]="dataList.count"></app-total-record-count>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!isFromUser">
    <ejs-grid #gridViewProfileLog [dataSource]='dataList' [enableInfiniteScrolling]='true' (dataBound)="dataBound()"
      [allowFiltering]="true" [allowResizing]="true" [pageSettings]="pageSettings" [height]="sharedService.ejsGridHeight">
      <e-columns>
        <e-column field='viewCreatedDateTime' headerText='Date' width=15>
           <ng-template #template let-data>
              {{data.viewCreatedDateTime | date:'MM/dd/yyyy h:mm a'}}
            </ng-template>
        </e-column>
        <e-column field='userName' headerText='User' width=30></e-column>
        <e-column field='tableName' headerText='Table' width=30></e-column>
        <e-column field='changeLog' headerText='Changes' width=80></e-column>
      </e-columns>
    </ejs-grid>
    <app-total-record-count [count]="dataList.length"></app-total-record-count>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>